// DateTime Picker - Vue2 Datetimepicker
//  https://www.npmjs.com/package/vue2-datepicker
//  (demo) https://mengxiong10.github.io/vue2-datepicker/demo/index.html

import Vue from 'vue'

import DatePicker from 'vue2-datepicker'
Vue.use(DatePicker)
